<div class="bcg_esign " style="justify-content: center; align-items: center; display: flex;    position: relative; top: 12rem;">
    <div class="card card_outLine">
        <div style="padding: 3rem 5rem;">
            <div style="display: flex; justify-content: center; align-items: center;">
                <img class="clickable" src="../../../assets/img/new-logo.png" height="60">
            </div>

             <div class="my-3" style="display: flex; justify-content: center;">
                <img  src="../../../assets/img/sign-cancelled.png" height="200">
            </div>

            <div class="mt-4">
                <h4 class="title_five" style="display: flex; justify-content: center;">The Signature has Failed.</h4>
            </div>

            <div class="mt-3">
                <h4 class="title_five" style="display: flex; justify-content: center;">{{sign_failure_reason}}</h4>
            </div>
        </div>
    </div>
</div>